import { AppButton, AppLoader } from 'components/atoms/CommonAppComponents';
import { IconDownload } from '@tabler/icons-react';
import { authTexts } from 'consts/text/index';
import { ButtonContainer, IconContainer } from './FetchInformationButton.styled';

export type FetchInformationButtonProps = {
    isLoading?: boolean;
    onClick?: () => void;
};

export const FetchInformationButton = ({ isLoading, onClick }: FetchInformationButtonProps) => {
    const icon = isLoading ? <AppLoader size={20} /> : <IconDownload size={20} />;

    return (
        <ButtonContainer>
            <AppButton disabled={isLoading} onClick={onClick} type="link" margin={0}>
                <IconContainer>{icon}</IconContainer>
                {authTexts.getDataButtonLabel}
            </AppButton>
        </ButtonContainer>
    );
};
